import React, { type JSX } from 'react';

import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

type SettingsFeatureDisclaimerProps = {
  children: string;
};

const SettingsFeatureDisclaimer = ({ children }: SettingsFeatureDisclaimerProps): JSX.Element => {
  return (
    <>
      <Divider />
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 2 }}>
        <VerifiedUserOutlinedIcon fontSize='small' color='action' sx={{ mt: 0.25 }} />
        <Typography variant='captionRegular' color='text.secondary'>
          {children}
        </Typography>
      </Box>
    </>
  );
};

export default SettingsFeatureDisclaimer;
